import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';

/**
 * 查询 clientUser list
 * @param {*} s
 */
export const queryClientUserList = params => {
    return request({
        url: requestUrl('/manage/clientUser/page'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 新增 clientUser
 * @param {*} s
 */
export const addClientUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/add'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 删除 clientUser
 * @param {*} s
 */
export const deleteClientUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/delete'),
        method: 'post',
        data: params
    });
};


/**
 * change clientUser status
 * @param {*} s
 */
export const changeClientUserStatus = params => {
    return request({
        url: requestUrl('/manage/clientUser/update/status'),
        method: 'post',
        data: requestParam(params)
    });
};
/**
 * change clientUser superuser
 * @param {*} s
 */
export const changeSuperFlag = params => {
    return request({
        url: requestUrl('/manage/clientUser/update/super'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * change clientUser is contact
 * @param {*} s
 */
export const changeClientUserContact = params => {
    return request({
        url: requestUrl('/manage/clientUser/update/contact'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * update clientUser
 * @param {*} s
 */
export const updateClientUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/update'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * batch update clientUser deactivate
 * @param {*} s
 */
export const updateDeactivate = params => {
    return request({
        url: requestUrl('/client/user/updateDeactivate'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * notifyUser
 * @param {*} s
 */
export const notifyUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/notifyUser'),
        method: 'post',
        data: requestParam(params)
    });
};


/**
 * sendNotificationEmail
 * @param {*} s
 */
export const sendNotificationEmail = params => {
    return request({
        url: requestUrl('/manage/clientUser/sendNotificationEmail'),
        method: 'post',
        data: requestParam(params)
    });
};

export const sendLoginNotificationEmail = params => {
    return request({
        url: requestUrl('/manage/clientUser/sendLoginNotificationEmail'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * downloadClientUserTemplate
 * @param {*} s
 */
export const downloadClientUserTemplate = params => {
    return request({
        url: requestUrl('/manage/clientUser/downloadClientUserTemplate'),
        method: 'get',
        data: requestParam(params),
        responseType: 'blob'
    });
};

// 导出列表
export const downloadClientUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    });
};


/**
 * importClientUserTemplate
 * @param {*} s
 */
export const importClientUserTemplate = params => {
    return request({
        url: requestUrl('/manage/clientUser/import'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
};

/**
 * getSiteConfig
 * @param {*} s
 */
export const getSiteConfig = params => {
    return request({
        url: requestUrl('/client/siteConfig/get'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * setDownloadLimit
 * @param {*} s
 */
export const setDownloadLimit = params => {
    return request({
        url: requestUrl('/siteConfig/setDownloadLimit'),
        method: 'post',
        data: requestParam(params)
    });
};

export const setAsGroupAuditorAndLimit = params => {
    return request({
        url: requestUrl('/siteConfig/setAsGroupAuditorAndLimit'),
        method: 'post',
        data: requestParam(params)
    });
};


/**
 * setDownloadable
 * @param {*} s
 */
export const setDownloadable = params => {
    return request({
        url: requestUrl('/siteConfig/setDownloadable'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * setWhiteList
 * @param {*} s
 */
export const setWhiteList = params => {
    return request({
        url: requestUrl('/siteConfig/setWhiteList'),
        method: 'post',
        data: requestParam(params)
    });
};

export const setIpWhiteList = params => {
    return request({
        url: requestUrl('/siteConfig/setIpWhiteList'),
        method: 'post',
        data: requestParam(params)
    });
};

export const batchDeleteClientUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/delete'),
        method: 'post',
        data: params
    });
}

export const batchUpdateClientUser = params => {
    return request({
        url: requestUrl('/manage/clientUser/batchUpdate'),
        method: 'post',
        data: requestParam(params)
    });
}
export const queryExistClientUserInfo = params => {
    return request({
        url: requestUrl('/manage/clientUser/queryExistClientUserInfo'),
        method: 'post',
        data: params
    });
}

//客户文件下载查询
export const downloadFileTracking = params => {
    return request({
        url: requestUrl('/client/site/downloadFileTracking'),
        method: 'post',
        data: params
    });
}

//客户文件下载详情
export const downloadFileDetail = params => {
    return request({
        url: requestUrl('/client/site/downloadFileDetail'),
        method: 'post',
        data: params
    });
}

//校验客户下载跟踪是否警告
export const checkDownloadIsOver = params => {
    return request({
        url: requestUrl('/client/site/checkDownloadIsOver'),
        method: 'post',
        data: params
    });
}

//客户文件下载导出
export const downloadFileTrackingExcel = params => {
    return request({
        url: requestUrl('/client/site/downloadFileTrackingExcel'),
        method: 'post',
        data: params,
        responseType: 'blob'
    });
}
